"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenize = exports.isNumeric = exports.padNumber = void 0;
const padNumber = (num, digitsAmount = 4) => num.toString().padStart(digitsAmount, '0');
exports.padNumber = padNumber;
const isNumeric = (value) => Number.isFinite(+value);
exports.isNumeric = isNumeric;
const tokenize = (query) => {
    let result = query.replace(/&&/g, ' && ').replace(/\|\|/g, ' || ');
    result = result.replace(/([+\-!(){}[\]^"~*?:.\\/])/g, ' $1 ');
    return result.replace(/\s+/g, ' ').trim();
};
exports.tokenize = tokenize;
//# sourceMappingURL=index.js.map